import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { logout, getUser } from '../../services/auth';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    // Get user from localStorage
    const userData = getUser();
    if (userData) {
      setUser(userData);
    } else {
      // Fetch from API if not in localStorage
      fetchUser();
    }
  }, []);

  const fetchUser = async () => {
    try {
      const response = await authAPI.getMe();
      if (response.data.success) {
        setUser(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch user:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      logout();
      navigate('/login');
    }
  };

  const getPageTitle = () => {
    const path = location.pathname;
    const titles = {
      '/': 'Dashboard',
      '/users': 'App Users',
      '/admin-users': 'Admin Users',
      '/sessions': 'Session Management',
      '/articles': 'Guidance Articles',
      '/duas': 'Duas Management',
      '/insights': 'Daily Insights',
      '/categories': 'Categories',
      '/notifications': 'Notifications',
      '/broadcasts': 'Broadcast History',
      '/media': 'Media Library',
      '/contact': 'Contact Information',
      '/logs': 'Error Logs',
    };
    return titles[path] || 'Admin Panel';
  };

  const getBreadcrumb = () => {
    const path = location.pathname;
    if (path === '/') return 'Overview and statistics';
    return 'Manage and monitor';
  };

  const getInitials = (name) => {
    if (!name) return 'A';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1>{getPageTitle()}</h1>
        <div className="header-breadcrumb">{getBreadcrumb()}</div>
      </div>

      <div className="header-right">
        <div className="position-relative">
          <div 
            className="header-user"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="header-avatar">
              {user ? getInitials(user.name) : 'A'}
            </div>
            <div className="header-user-info d-none d-md-block">
              <div className="header-user-name">{user?.name || 'Admin'}</div>
              <div className="header-user-role">{user?.role || 'Administrator'}</div>
            </div>
            <i className="bi bi-chevron-down ms-2"></i>
          </div>

          {showDropdown && (
            <div 
              className="dropdown-menu show position-absolute end-0 mt-2"
              style={{ minWidth: '200px' }}
            >
              <div className="dropdown-item disabled">
                <small className="text-muted">Signed in as</small>
                <div className="fw-bold">{user?.email}</div>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item text-danger" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right me-2"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Close dropdown when clicking outside */}
      {showDropdown && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 99 }}
          onClick={() => setShowDropdown(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;